import moment from 'moment';

export const STUDY_LIST_DEFAULTS = {
  patientName: '',
  mrn: '',
  studyDate: {
    startDate: moment().subtract(2, 'month').format('YYYYMMDD'),
    endDate: moment().format('YYYYMMDD'),
  },
  description: '',
  modalities: [],
  accession: '',
  sortBy: 'studyDate',
  sortDirection: 'ascending',
  pageNumber: 1,
  resultsPerPage: 25,
  datasources: '',
};

export const getStudyListDefaultFilterValues = () => ({
  ...STUDY_LIST_DEFAULTS,
  studyDate: {
    startDate: moment().subtract(2, 'month').format('YYYYMMDD'),
    endDate: moment().format('YYYYMMDD'),
  },
});
